<template>
	<div>
		<div
			class="form-check cm-form-check"
			:class="[className, activeFilter ?? 'active']"
		>
			<input
				class="form-check-input"
				type="checkbox"
				:id="'check-' + field.adPropertyKey"
				v-model="model"
				@change="updateFilter()"
				true-value="1"
				false-value="2"
				:checked="activeFilter === 1"
			/>
			<label class="form-check-label" :for="'check-' + field.adPropertyKey"
				>{{ refData[field.adPropertyKey] }}
				<template v-if="field.hits[0].count > 0">
					({{ field.hits[0].count }})
				</template>
			</label>
		</div>
	</div>
</template>

<script>
import store from '@/store'

export default {
	name: 'FormCheck',
	data() {
		return {
			model: 2,
		}
	},
	computed: {
		activeFilter() {
			// @habamedia bug with dd-datteln, dd-castrop
			// field is undefined
			console.log('this.field:: ', this.field, this.className, this.refData)

			if (store.state.filterItems[this.field.adPropertyKey]) {
				return 1
			} else {
				return 2
			}
		},
	},
	props: {
		className: {
			type: String,
			default: '',
		},
		field: {
			type: Object,
			required: true,
		},
		refData: {
			type: Object,
			required: true,
		},
	},
	methods: {
		updateFilter() {
			if (this.model === '1') {
				store.commit('updateFilter', {
					adPropertyKey: this.field.adPropertyKey,
					adPropertyType: this.field.adPropertyType,
					adPropertyValue: true,
				})
			} else {
				store.commit('deleteFilter', this.field.adPropertyKey)
			}

			this.$emit('updateFilter')
		},
	},
	created() {
		if (store.state.filterItems[this.field.adPropertyKey] !== undefined) {
			this.model = 1
		}
		this.unsubscribe = store.subscribe((mutation, state) => {
			if (
				mutation.type === 'deleteFilter' ||
				mutation.type === 'deleteAllFilter'
			) {
				if (
					state.filterItems[this.field.adPropertyKey] === undefined &&
					this.model === '1'
				) {
					this.model = '2'
				}
			}
		})
	},
	beforeUnmount() {
		this.unsubscribe()
	},
}
</script>
<style lang="scss">
.cm-form-check {
	&.active .form-check-label {
		color: $primary;
	}
}
</style>
